import React from 'react';
import './RadioCard.scss';

interface RadioCardProps {
  value: string;
  selectedValue: string;
  onChange: (value: string) => void;
  title: string;
  description?: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

const RadioCard: React.FC<RadioCardProps> = ({
  value,
  selectedValue,
  onChange,
  title,
  description,
  children,
  disabled = false,
}) => {
  const isSelected = value === selectedValue;

  return (
    <label
      className={`radio-card 
        ${isSelected ? 'radio-card-selected' : ''} 
        ${disabled ? 'radio-card-disabled' : ''}`}
    >
      <input
        type="radio"
        name="radio-group"
        checked={isSelected}
        onChange={() => onChange(value)}
        disabled={disabled}
        className="radio-card-input"
      />

      <div className="radio-card-circle" />

      <div className="radio-card-content">
        <div className="radio-card-title">{title}</div>

        {description && (
          <div className="radio-card-description">{description}</div>
        )}

        {isSelected && children && (
          <div className="radio-card-extra">{children}</div>
        )}
      </div>
    </label>
  );
};

export default RadioCard;
